export const FR = {}
